import React from 'react';

export const useLocalStorageState = (key, initialValue) => {
  const [internalState, setInternalState] = React.useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      return initialValue;
    }
  });

  React.useEffect(() => {
    try {
      const item = window.localStorage.getItem(key);
      setInternalState(item ? JSON.parse(item) : initialValue);
    } catch (error) {
      setInternalState(initialValue);
    }
  }, [key, initialValue]);

  const setState = React.useCallback((newValue) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(newValue));
      setInternalState(newValue);
    } catch (error) {
      // Intended
      return null;
    }
  }, [key]);

  return [internalState, setState];
};

export default useLocalStorageState;
